module.exports = __webpack_public_path__ + "static/bg9-7d2facc52e51e6dd0969bd739e767ccb.jpg";